import styled from "styled-components"

// T-W2-F2 (2026-07-04): shared styles for the LinkedIn export upload row + match-proposals
// queue. Visual language matches ConnectorItem/DeviceSyncedRow (contactsStyles.js) -- this
// surface has no mobile equivalent (grepped teeup-mobile, none found; rule 17b), so it keeps
// the existing Sync Contacts card language rather than inventing a new one.

export const LinkedInFileInput = styled.div`
  position: relative;
  display: inline-block;

  input[type="file"] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
  }

  input[type="file"]:disabled {
    cursor: default;
  }
`

export const ProposalsWrapper = styled.div`
  width: 100%;
  background-color: var(--white);
  border-radius: 8px;
  box-sizing: border-box;
  padding: 16px;
  margin-top: 12px;
`

export const ProposalRow = styled.div`
  width: 100%;
  border-bottom: 1px solid var(--lightGray2);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 12px 5px;

  &:last-child {
    border-bottom: none;
  }
`

export const ProposalLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`

export const ProposalActions = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
`
